export default __webpack_public_path__ + "4da0b13b2fb77a7bf7c73ac7ff40be5d.ogg";